import { useCallback, useEffect, useMemo, useState } from 'react';
import { DateTime } from 'luxon';
import { useNotesBackgroudTimerContext } from 'modules/NotesBackgroudTimer/context/NotesBackgroudTimerContext';
import { useFormattedDuration } from 'modules/notes/common';
import { useNotesBackgroudTimer } from 'modules/NotesBackgroudTimer/hooks/useNotesBackgroudTimer';

export default function useBackgroundTimerValue() {
  const {
    getCurrentInlineTimerDuration,
    running,
    signalMeta
  } = useNotesBackgroudTimerContext();
  const { onStop } = useNotesBackgroudTimer();
  const [timerDuration, setTimerDuration] = useState(0);
  const formattedDuration = useFormattedDuration({
    duration: timerDuration,
    longDurationFormat: running,
    needsLeadingZeroes: true
  });

  const setDurationValue = useCallback(() => {
    const currentDuration = getCurrentInlineTimerDuration();
    if (!currentDuration) {
      setTimerDuration(0);
      return;
    }
    setTimerDuration(currentDuration);
  }, [getCurrentInlineTimerDuration]);

  useEffect(() => {
    if (!running) {
      setTimerDuration(0);
      return;
    }
    setDurationValue();
    const interval = setInterval(() => {
      setDurationValue();
    }, 1000);
    return () => {
      clearTimeout(interval);
      setTimerDuration(0);
    };
  }, [setDurationValue, running]);

  //if midnight crossed stop the background timer automatically
  useEffect(() => {
    if (!signalMeta) return;
    if (
      running &&
      timerDuration > 0 &&
      DateTime.local() >=
        DateTime.fromISO(signalMeta?.date).toLocal().endOf('day')
    ) {
      onStop();
    }
  }, [signalMeta, running, timerDuration, onStop]);

  return useMemo(
    () => ({
      fromattedTimerValue: formattedDuration
    }),
    [formattedDuration]
  );
}
